import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { HeroNew } from './pages/HeroNew';
import { Heroes } from './pages/Heroes';
import { Home } from './pages/Home';
import { Profile } from './pages/Profile';
import { Stories } from './pages/Stories';
import { StoryDetail } from './pages/StoryDetail';
import { StoryNew } from './pages/StoryNew';

export const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/stories/:storyId', element: <StoryDetail /> },
  {
    element: <AppShell />,
    children: [
      { path: '/profile', element: <Profile /> },
      { path: '/heroes', element: <Heroes /> },
      { path: '/heroes/new', element: <HeroNew /> },
      { path: '/stories', element: <Stories /> },
      { path: '/stories/new', element: <StoryNew /> },
    ],
  },
]);
